/**
 * useDragScroll - Options API compatible drag scroll composable
 * 替代 vue-dragscroll 套件
 */
export function useDragScroll() {
  let el = null
  let isDown = false
  let startX = 0
  let startY = 0
  let scrollLeft = 0
  let scrollTop = 0
  let velocityX = 0
  let velocityY = 0
  let timestamp = 0
  let rafId = null

  const mousedownHandler = (e) => {
    // 右鍵選單 / 中鍵自動捲動時 mouseup 不會回到元素上，進入拖曳會卡在 isDown
    if (e.button !== 0) return
    // 巢狀拖曳容器只由最內層「實際可捲動」的那層處理，避免同一次拖曳被套用兩次；不可捲動時交給外層
    if (e.dragScrollHandled) return
    if (el.scrollWidth <= el.clientWidth && el.scrollHeight <= el.clientHeight) return
    e.dragScrollHandled = true
    isDown = true
    el.style.cursor = 'grabbing'
    el.style.userSelect = 'none'
    startX = e.pageX - el.offsetLeft
    startY = e.pageY - el.offsetTop
    scrollLeft = el.scrollLeft
    scrollTop = el.scrollTop
    velocityX = 0
    velocityY = 0
    timestamp = Date.now()
    cancelMomentumTracking()
  }

  const mouseupHandler = () => {
    // 拖曳已因 mouseleave 結束時不可再觸發慣性，否則會用殘留速度讓列表突然滑動
    if (!isDown) return
    isDown = false
    el.style.cursor = 'grab'
    el.style.removeProperty('user-select')
    beginMomentumTracking()
  }

  const mouseleaveHandler = () => {
    if (isDown) {
      isDown = false
      el.style.cursor = 'grab'
      el.style.removeProperty('user-select')
    }
  }

  const mousemoveHandler = (e) => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - el.offsetLeft
    const y = e.pageY - el.offsetTop
    const walkX = (x - startX) * 1.5
    const walkY = (y - startY) * 1.5
    const prevScrollLeft = el.scrollLeft
    const prevScrollTop = el.scrollTop

    el.scrollLeft = scrollLeft - walkX
    el.scrollTop = scrollTop - walkY

    // 計算速度（用於慣性滾動）
    const now = Date.now()
    const dt = now - timestamp
    if (dt > 0) {
      velocityX = (el.scrollLeft - prevScrollLeft) / dt
      velocityY = (el.scrollTop - prevScrollTop) / dt
      timestamp = now
    }
  }

  const beginMomentumTracking = () => {
    cancelMomentumTracking()
    rafId = requestAnimationFrame(momentumLoop)
  }

  const cancelMomentumTracking = () => {
    if (rafId) {
      cancelAnimationFrame(rafId)
      rafId = null
    }
  }

  const momentumLoop = () => {
    if (!el) return

    el.scrollLeft += velocityX * 10
    el.scrollTop += velocityY * 10
    velocityX *= 0.95
    velocityY *= 0.95

    if (Math.abs(velocityX) > 0.5 || Math.abs(velocityY) > 0.5) {
      rafId = requestAnimationFrame(momentumLoop)
    }
  }

  const init = (element) => {
    if (!element) return

    el = element
    el.style.cursor = 'grab'

    el.addEventListener('mousedown', mousedownHandler)
    el.addEventListener('mouseup', mouseupHandler)
    el.addEventListener('mouseleave', mouseleaveHandler)
    el.addEventListener('mousemove', mousemoveHandler)
  }

  const destroy = () => {
    if (!el) return

    cancelMomentumTracking()

    el.removeEventListener('mousedown', mousedownHandler)
    el.removeEventListener('mouseup', mouseupHandler)
    el.removeEventListener('mouseleave', mouseleaveHandler)
    el.removeEventListener('mousemove', mousemoveHandler)

    el.style.cursor = ''
    el.style.removeProperty('user-select')
    el = null
  }

  return {
    init,
    destroy,
  }
}
